"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactRedux = require("react-redux");

var _FileDetail = _interopRequireDefault(require("../../components/browser/FileDetail"));

var _Folders = require("FileManagerCore/selectors/Folders");

var _Canva = require("FileManagerCore/actions/Canva");

var _Canva2 = require("FileManagerCore/selectors/Canva");

var _Permissions = require("FileManagerCore/selectors/Permissions");

var _Files = require("../../actions/Files");

var _Actions = require("../../actions/Actions");

var _Configuration = require("../../selectors/Configuration");

var _Panel = require("../../selectors/Panel");

var _Files2 = require("../../selectors/Files");

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    parentFolder: (0, _Panel.getParentFolderForSelectFile)(state),
    isBrowsingFolder: (0, _Panel.getIsBrowsingFolder)(state),
    folderCount: (0, _Folders.getFoldersCount)(state),
    isHostAppContextPrivate: (0, _Configuration.getIsHostAppContextPrivate)(state),
    isCanvaFile: (0, _Canva2.getIsCanvaFile)(state, {
      file: props.tile.get('file')
    }),
    isReadOnly: (0, _Permissions.getIsReadOnly)(state),
    uploadedFileAccess: (0, _Configuration.getUploadedFileAccess)(state),
    isSingleFileFetched: (0, _Files2.getIsSelectedSingleFileFetched)(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    trackInteraction: function trackInteraction() {
      return dispatch(_Actions.trackInteraction.apply(void 0, arguments));
    },
    onAcquireFromCanva: function onAcquireFromCanva(_ref) {
      var canvaDesignId = _ref.canvaDesignId,
          fileUrl = _ref.fileUrl,
          originalFileId = _ref.originalFileId,
          fileName = _ref.fileName,
          uploadedFileAccess = _ref.uploadedFileAccess;
      dispatch((0, _Canva.acquireFileFromCanva)({
        canvaDesignId: canvaDesignId,
        fileUrl: fileUrl,
        originalFileId: originalFileId,
        fileName: fileName,
        uploadedFileAccess: uploadedFileAccess
      }));
    },
    onDelete: function onDelete(file) {
      dispatch((0, _Files.removeFile)(file));
    },
    onMove: function onMove(file, folder) {
      dispatch((0, _Files.moveFile)(file, folder.get('id')));
    },
    onRename: function onRename(file, newName) {
      return dispatch((0, _Files.renameFile)(file, newName));
    },
    onUpdateHeight: function onUpdateHeight(file, height) {
      dispatch((0, _Actions.updateDetailHeight)(file, height));
    }
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_FileDetail.default);

exports.default = _default;
module.exports = exports.default;